import axios from 'axios'
import { errorHandlerRestV2 } from '@/services/rest-api/errorHandlerRest'

import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_IDENTITY

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/client/token',
    params,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/oauth/public-token',
    data,
  })

  return response?.data
}

export const revoke = async (data) => {
  // Axios instance need to be recreated because apiClientV2 still use
  // resource token from token and cant be redefine the headers here
  const axiosInstance = axios.create({
    headers: {
      Authorization: `Bearer ${data.token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  axiosInstance.interceptors.response.use((response) => response, errorHandlerRestV2)

  const response = await axiosInstance({
    baseURL,
    method: 'POST',
    url: `/oauth/token/revoke`,
    data,
  })

  return response?.data
}
